module.exports = __webpack_public_path__ + "static/media/mail-black.02c2cb12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mail-black.svg
// module id = 493
// module chunks = 0